/**
 * Minimal replacement for Q.defer(): exposes resolve/reject alongside a Promise.
 */
export function createDeferred() {
  let resolve;
  let reject;
  const promise = new Promise((res, rej) => {
    resolve = res;
    reject = rej;
  });
  return { promise, resolve, reject };
}



// WEBPACK FOOTER //
// ./src/utils/deferred.js